<template>
  <d-navbar-nav class="border-left flex-row">
    <li class="nav-item border-right dropdown notifications">
      <span class="nav-link nav-link-icon text-center" v-d-toggle.notifications>
        <div class="nav-link-icon__wrapper">
          <i class="material-icons">&#xE7F4;</i>
          <d-badge pill theme="danger">{{countUnread}}</d-badge>
        </div>
      </span>
      <d-collapse id="notifications" ref="notifications" class="dropdown-menu dropdown-menu-small" v-if="countUnread > 0" >
        <span
          class="dropdown-item"
          role="menuitem"
          v-for="(quotation, index) in quotations"
          :key="index"
          @click.prevent="unread(quotation, index)"
        >
          <div class="notification__icon-wrapper">
            <div class="notification__icon">
              <i class="material-icons">note_add</i>
            </div>
          </div>
          <div class="notification__content">
            <span class="notification__category">Orçamento</span>
            <p>
              {{ quotation.reference_no }} - {{ quotation.customer_name }}
              <span
                class="text-danger text-semibold"
              >{{ quotation.sent_at }}</span>
            </p>
          </div>
        </span>
        <span class="dropdown-item notification__all text-center" @click="closeNotifications()">
          <router-link :to="{ name: 'admin-overview' }">Ver todos</router-link>
        </span>
      </d-collapse>
    </li>
    <li class="nav-item dropdown">
      <span class="nav-link dropdown-toggle text-nowrap px-3" v-d-toggle.user-actions>
        <img
          class="user-avatar rounded-circle mr-2"
          src="@/assets/images/avatars/enhanced-buzz.jpeg"
          alt="User Avatar"
        >
        <span class="d-none d-md-inline-block">{{ user.name }}</span>
      </span>
      <d-collapse id="user-actions" ref="userActions" class="dropdown-menu dropdown-menu-small">
        <span class="dropdown-item" @click="closeUserActions()">
          <router-link :to="{name: 'admin-perfil'}">
            <i class="material-icons">&#xE7FD;</i> Perfil
          </router-link>
        </span>
        <span class="dropdown-item" @click="closeUserActions()">
          <router-link :to="{name: 'admin-settings'}">
            <i class="material-icons">settings</i> Configuração
          </router-link>
        </span>
        <d-dropdown-divider/>
        <span class="dropdown-item text-danger">
          <div @click.prevent="logout()">
            <i class="material-icons text-danger">&#xE879;</i> Sair
          </div>
        </span>
      </d-collapse>
    </li>
  </d-navbar-nav>
</template>

<script>
import { mapActions } from 'vuex';
import Echo from '_common/runs/pusher';
import DashboardService from '_services/rest/modules/dashboard';

export default {
  name: 'navbar-nav',
  computed: {
    user() {
      const { user } = this.$store.state.user;
      if (user) {
        return user;
      }
      return { name: 'Admin' };
    },
  },
  data() {
    return {
      quotations: [],
      countUnread: null,
    };
  },
  methods: {
    ...mapActions({
      activeAlert: 'activeAlert',
      storeLogout: 'logout',
    }),
    logout() {
      this.storeLogout().then(() => {
        this.$router.push('/public/login');
      });
    },
    closeUserActions() {
      this.$refs.userActions.show = false;
    },
    closeNotifications() {
      this.$refs.notifications.show = false;
    },
    unread(quotation, index) {
      this.closeNotifications();
      DashboardService.setReadNotification(quotation.id)
        .then(() => {
          this.quotations.splice(index, 1);
          this.countUnread -= this.countUnread;
          this.$router.push({ name: 'admin-quotation-edit', params: { quotationId: quotation.id } });
        });
    },
    setQuotation(quotation) {
      this.quotations = quotation.list;
      this.countUnread = (quotation.total_items > 0) ? quotation.total_items : null;
    },
  },
  mounted() {
    DashboardService.getNotificationsAlerts()
      .then(response => {
        this.setQuotation(response);
      });
    Echo.channel('alertChannel')
      .listen('ExpiredQuotationAlertEvent', event => {
        this.setQuotation(event.quotations);
        this.activeAlert({ message: 'Há orçamentos que venceram hoje', theme: 'info' });
      });
  },
};
</script>


<style>
.nav-link:hover {
  cursor: pointer;
}
</style>
